import React, { useMemo } from "react"
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectWorkQueue } from "../lib/workQueueNavigation";

export default function QueuesMenuGrouped({classes, workqSlug, allWorkQGrouped}) {
    const dispatch = useDispatch();
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    const parentItemsByGroup = useMemo(() => {
        if (!allWorkQGrouped) return []
        return allWorkQGrouped
            .map((group) => {
                const wq = group.workQs || []
                const parents = wq.filter((item) => item.parent_id == null)
                // Group only lists child queues (parent row not in this group): still show them in the menu
                const usedFallback = parents.length === 0 && wq.length > 0
                const parentItems = usedFallback ? wq : parents
                return {
                    groupId: group.id,
                    groupName: group.name,
                    parentItems,
                    showGroupLabel:
                        usedFallback && group.id !== "undetermined" && !!group.name,
                }
            })
            .filter((g) => g.parentItems.length > 0)
    }, [allWorkQGrouped])

    const childrenByParentId = useMemo(() => {
        const map = new Map()
        if (!allWorkQGrouped) return map
        allWorkQGrouped.forEach((group) => {
            (group.workQs || []).forEach((item) => {
                if (item.parent_id == null) return
                const existing = map.get(item.parent_id) || []
                map.set(item.parent_id, [...existing, item])
            })
        })
        return map
    }, [allWorkQGrouped])

    const handleQueueLinkClick = (item) => {
        selectWorkQueue(dispatch, item)
    }

    return <li  className={classes.link_cases}>
        <NavLink to={`/work-queues/${selectedWorkQueue?.slug}`} className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-folder"></i>Queues</NavLink>
        {allWorkQGrouped && (
            <div className={classes.modal_last_cases}>
                <div className={classes.sub_menu}>
                    {parentItemsByGroup.map((group) => (
                        <React.Fragment key={group.groupId}>
                            <div className={classes.group_item}>
                                {group.showGroupLabel && (
                                    <div className={classes.queues_menu_group_label}>{group.groupName}</div>
                                )}
                                {group.parentItems.map((item) => (
                                    <React.Fragment key={item.id}>
                                        <div className={classes.sub_menu_item} data-id={item.id}>
                                            <Link
                                                to={`/work-queues/${item.slug}`}
                                                onClick={() => handleQueueLinkClick(item)}
                                                className={workqSlug == item.slug ? classes.active_item : ""}
                                            >
                                                {item.name}
                                            </Link>
                                        </div>
                                        {(childrenByParentId.get(item.id) || []).map((child) => (
                                            <div
                                                key={`child-${child.id}`}
                                                className={`${classes.sub_menu_item} ${classes.sub_menu_item_child}`}
                                                data-id={child.id}
                                            >
                                                <Link
                                                    to={`/work-queues/${child.slug}`}
                                                    onClick={() => handleQueueLinkClick(child)}
                                                    className={workqSlug == child.slug ? classes.active_item : ""}
                                                >
                                                    {child.name}
                                                </Link>
                                            </div>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        )}
    
    </li>
}
